"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _sortableitem = _interopRequireDefault(require("./sortableitem/sortableitem"));

var _errormessage = _interopRequireDefault(require("../../form/field/errormessage/errormessage"));

var _index = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _sortablelist_styles = _interopRequireDefault(require("./sortablelist_styles"));

var _sortablelist_definition = _interopRequireDefault(require("./sortablelist_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/* READ BEFORE IMPLEMENTING:
Components that implement this component must provide a handleChange function as a prop which handles selections/deselections of drag item checkboxes;
this function will be called with the new value being selected/deselcted along with the current order of items which may or may not be utilized.
For dragEnd events, the parent function handleOrderChange will be called with the new item list (order changed).
These functions are ideal for logic used to calculate next order/checked state of the items passed to sortablelist.
For an example implementation of the handleChange and handleOrderChange functions, see pages/dashboard/reports/details/dimensions/dimensions.js
*/

/* ========== ~~~~~~~~~~ EXPORT : LIST : SORTABLE ~~~~~~~~~~ ========== */


var SortableList = (0, _reactJss.default)(_sortablelist_styles.default)(function (props) {
  //Function to render item list based on selected props and items passed from parent.
  var getItems = function getItems() {
    if (props.order.length === 0) {
      return generateItems(getInitialOrder());
    } else {
      return generateItems(props.order);
    }
  };

  var generateItems = function generateItems(orderedList) {
    return orderedList.map(function (value, index) {
      return _react.default.createElement(_reactBeautifulDnd.Draggable, {
        key: value,
        draggableId: value,
        index: index
      }, function (provided) {
        return _react.default.createElement("div", _extends({
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps), _react.default.createElement(_sortableitem.default, _extends({
          key: index
        }, props, {
          handleSelect: handleSelect,
          item: props.items.filter(function (item) {
            return item.value === value;
          })
        })));
      });
    });
  }; //Get initial order is called to place the selected items at the top of the list in the order they appear in,
  // upon the mounting of the sortable list component and other cases where props.order is empty (default).


  var getInitialOrder = function getInitialOrder() {
    if (props.selected.length === 0) {
      return transpileItems(props.items);
    } else {
      var initialOrder = Array.from(props.items);
      var selectedOrder = [];

      for (var i = 0; i < props.selected.length; i++) {
        for (var k = 0; k < initialOrder.length; k++) {
          if (initialOrder[k].value === props.selected[i]) {
            selectedOrder.push(initialOrder[k]);
          }
        }
      }

      return transpileItems(selectedOrder.concat(initialOrder.filter(function (currentValue) {
        return !selectedOrder.includes(currentValue);
      })));
    }
  }; //Function to call handleChange function in parent upon sortable item being selected/deselected


  var handleSelect = function handleSelect(value) {
    if (props.order.length === 0) {
      props.handleChange(getInitialOrder(), value);
    } else {
      props.handleChange(props.order, value);
    }
  }; //Function which reorders given list by swapping items at the specified starting and ending indices.


  var reorder = function reorder(list, startIndex, endIndex) {
    //remove the reordered item from previous position
    var result = Array.from(list);

    var _result$splice = result.splice(startIndex, 1),
        _result$splice2 = _slicedToArray(_result$splice, 1),
        removed = _result$splice2[0]; //insert the reordered item into the new position


    result.splice(endIndex, 0, removed);
    return result;
  }; //Callback function for item drag end, reorders items using reorder function above and assigns to this.props.order, by calling
  //handleOrderChange function with new ordered list of all itemn.


  var onDragEnd = function onDragEnd(result) {
    if (!result.destination) {
      return;
    }

    var items = reorder(props.order.length === 0 ? getInitialOrder() : props.order, result.source.index, result.destination.index);
    props.handleOrderChange(items);
  }; //Transpile items returns the list of values corresponding to the given list of items.


  var transpileItems = function transpileItems(itemList) {
    var returnedArray = [];

    for (var i = 0; i < itemList.length; i++) {
      returnedArray[i] = itemList[i].value;
    }

    return returnedArray;
  };

  return _react.default.createElement("div", {
    className: "list sortablelist ".concat((0, _index.generateClasses)(props), " ").concat(props.classes.sortablelist)
  }, _react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, _react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable"
  }, function (provided) {
    return _react.default.createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef
    }), getItems());
  })), props.error.enabled ? _react.default.createElement(_errormessage.default, {
    klass: 'errormessage'
  }, props.error.message) : null);
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(SortableList, _sortablelist_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = SortableList;
exports.default = _default;